import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Manpower from "./manpower";
import Machinary from "./machinery";
import Material from "./material";
export default function ResourceRecord({ project }) {
  return (
    <React.Fragment>
      <Tabs>
        <div className="row" id="risk-register">
          <div className="col-12">
            <TabList>
              <Tab>Manpower</Tab>
              <Tab>Machinery</Tab>
              {/* <Tab>Material</Tab> */}
            </TabList>
          </div>
          {/* <hr /> */}
        </div>
        <div className="row" style={{ marginLeft: 0 }}>
          <TabPanel>
            <Manpower project={project} />
          </TabPanel>
          <TabPanel>
            <Machinary project={project} />
          </TabPanel>
          {/* <TabPanel>
            <Material project={project} />
          </TabPanel> */}
        </div>
      </Tabs>
    </React.Fragment>
  );
}
